import React, { useEffect, useState } from 'react';
import { NCZIEntry } from '../../../../Interfaces/ncziTypes';
import EHREntryInfo from './EHREntryInfo';
import EHREntryItem from './EntryItem/EHREntryItem';
import NZCIListItem from '../../../Base/NZCIListItem';
// @ts-ignore
import styles from './EHREntry.module.scss';
import Tag from '../../../../../../Components/Tag/Tag';

interface Props {
	item: NCZIEntry | undefined;
}

const EHREntry: React.FC<Props> = props => {
	const { item } = props;

	if (!item) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			{/*<NZCIListItem*/}
			{/*	title='nczi.name'*/}
			{/*	value={item.info?.version === 'VER04' ? <>{item.name} <Tag label={'nczi.cancelled'} className={styles.cancelledTag} /></> : item.name}*/}
			{/*	// extra={item.archetypeId}*/}
			{/*/>*/}
			{item.info?.version === 'VER04' && (
				<Tag label={'nczi.cancelled'} className={styles.cancelledTag} />
			)}
			<EHREntryInfo info={item.info} />
			{item.items.map((entryItem, key) => (
				<EHREntryItem item={entryItem} key={key} />
			))}
		</div>
	);
};

export default EHREntry;
